var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-container',{staticClass:"d-flex flex-column min-height-100 p-0",attrs:{"fluid":"","id":"app"}},[_c('Header'),_c('b-container',{staticClass:"main justify-content-center p-0",attrs:{"fluid":""}},[_c('router-view')],1),_c('Footer')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }